export default __webpack_public_path__ + "static/aibWhite-1a111151bd7069aefec12c1e8325334b.webp";